import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {supportCategories} from '../data/supportResources';
import './SupportResources.css';

const {FiAlertTriangle,FiArrowUpRight,FiHeart,FiShield}=FiIcons;

function ResourceAction({action}) {
  const isExternal=action.type==='external' || action.type==='whatsapp';

  return (
    <a
      className={`resource-action${action.primary ? ' resource-action-primary' : ''}`}
      href={action.href}
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noreferrer' : undefined}
    >
      <span>{action.label}</span>
      {isExternal && <SafeIcon icon={FiArrowUpRight} />}
    </a>
  );
}

function ResourceCard({resource}) {
  return (
    <article className="support-resource-card">
      <div className="support-resource-copy">
        <h3>{resource.name}</h3>
        {resource.audience && <p className="support-resource-audience">{resource.audience}</p>}
        <p className="support-resource-description">{resource.description}</p>
        {resource.details?.length > 0 && (
          <ul className="support-resource-details">
            {resource.details.map((detail)=><li key={detail}>{detail}</li>)}
          </ul>
        )}
        {resource.note && <p className="support-resource-note">{resource.note}</p>}
      </div>
      <div className="support-resource-actions">
        {resource.actions.map((action)=><ResourceAction action={action} key={action.label} />)}
      </div>
      {resource.references?.length > 0 && (
        <div className="support-resource-references">
          {resource.references.map((reference)=>(
            <a href={reference.href} key={reference.href} target="_blank" rel="noreferrer">
              {reference.label}<SafeIcon icon={FiArrowUpRight} />
            </a>
          ))}
        </div>
      )}
    </article>
  );
}

function SupportResources() {
  return (
    <section className="support-resources-page">
      <div className="page-intro">
        <span className="eyebrow"><SafeIcon icon={FiHeart} /> Support and safety</span>
        <h1>Helplines and support resources</h1>
        <p>Find reporting channels,urgent help,and support options in Malaysia. Choose the resource that best fits your situation.</p>
      </div>

      <div className="support-urgent-notice" role="note">
        <span className="support-urgent-icon"><SafeIcon icon={FiAlertTriangle} /></span>
        <div>
          <h2>Need help now?</h2>
          <p>If you or someone else is in immediate danger,call 999. You do not need to wait for a report to be reviewed before seeking help.</p>
        </div>
        <a className="resource-action resource-action-emergency" href="tel:999">Call 999</a>
      </div>

      <div className="support-category-list">
        {supportCategories.map((category)=>(
          <section className="support-category" key={category.id} aria-labelledby={`${category.id}-title`}>
            <div className="support-category-heading">
              <span className="support-category-icon"><SafeIcon icon={FiShield} /></span>
              <div>
                <h2 id={`${category.id}-title`}>{category.title}</h2>
                <p>{category.description}</p>
              </div>
            </div>
            <div className="support-resource-grid">
              {category.resources.map((resource)=>(
                <ResourceCard resource={resource} key={resource.name} />
              ))}
            </div>
          </section>
        ))}
      </div>

      <aside className="support-safety-notice">
        <h2>A note about this community</h2>
        <p>Bully-Free Malaysia is a community awareness,reporting,and support platform. It is not an emergency response service and does not replace professional,medical,psychological,legal,or law enforcement assistance.</p>
        <p>Please protect privacy. Do not publish personal addresses,phone numbers,private conversations,or identifying information about children or other people without appropriate authorisation.</p>
      </aside>
    </section>
  );
}

export default SupportResources;